import mapcatJson from '../../../public/assets/mapcat.json';
import color from 'color';
import config from '../configProvider';

const colorProps = [
  'background-color',
  'fill-color',
  'line-color',
  'fill-outline-color',
  'text-color',
  'text-halo-color',
  'icon-color'
];

export default function(grayScale = true) {
  let root =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '') +
    process.env.BASE_URL;

  let tileUrl = config.getEnv(config.enum.VUE_APP_TILE_URL);
  if (!tileUrl) {
    tileUrl = 'https://vt-dev.mapcat.com/osm/hungary/tile/{z}/{x}/{y}.pbf';
  } else if (tileUrl.startsWith('/')) {
    tileUrl = root + tileUrl.substring(1);
  }

  mapcatJson.sources['composite'].tiles = [tileUrl];
  mapcatJson.sources['composite.poi'].tiles = [tileUrl];
  mapcatJson.sources['composite.shape'].tiles = [tileUrl];
  mapcatJson.sprite = root + '/assets/sprite';
  mapcatJson.glyphs = root + '/assets/fonts/{fontstack}/{range}.pbf';

  if (grayScale) {
    mapcatJson.layers.forEach((element) => {
      const paint = element.paint;
      if (paint) {
        colorProps.forEach((property) => {
          if (paint[property]) {
            // multiple colors with stops
            if (paint[property].stops) {
              paint[property].stops.forEach((stop) => {
                let newColor;
                if (element.id.match(/^water/)) {
                  newColor = color(paint[property])
                    .whiten(0.5)
                    .hex();
                } else {
                  newColor = color(stop[1])
                    .grayscale()
                    .hex();
                }
                stop[1] = newColor;
              });
            } else {
              let newColor;
              if (element.id.match(/^water/)) {
                newColor = color(paint[property])
                  .whiten(0.5)
                  .hex();
              } else {
                // one simple color
                newColor = color(paint[property])
                  .grayscale()
                  .hex();
              }
              paint[property] = newColor;
            }
          }
        });
      }
    });
  }

  // current year in attribution
  for (const source of Object.keys(mapcatJson.sources)) {
    if (mapcatJson.sources[source].attribution) {
      mapcatJson.sources[source].attribution = mapcatJson.sources[
        source
      ].attribution.replace(/© \d\d\d\d /, `© ${new Date().getFullYear()} `);
    }
  }
  return mapcatJson;
}
